import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getResidueCollectedList as getResidueCollectedListApi,
	getResidueCollected as getResidueCollectedApi,
	addNewResidueCollected as addNewResidueCollectedApi,
	updateResidueCollected as updateResidueCollectedApi,
	deleteResidueCollected as deleteResidueCollectedApi,
} from '../../helpers/residue/backend_helper';

export const getResidueCollectedList = createAsyncThunk('residueCollecteds/getResidueCollectedList', async (params) => {
	try {
		const response = getResidueCollectedListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getResidueCollected = createAsyncThunk('residueCollecteds/getResidueCollected', async residueCollected_id => {
	try {
		const response = getResidueCollectedApi(residueCollected_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewResidueCollected = createAsyncThunk('residueCollecteds/addNewResidueCollected', async residueCollected => {
	try {
		const response = addNewResidueCollectedApi(residueCollected);
		toast.success('ResidueCollected agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar residueCollected.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateResidueCollected = createAsyncThunk('residueCollecteds/updateResidueCollected', async (residueCollected) => {
		try {
			const response = updateResidueCollectedApi(residueCollected);
			toast.success('ResidueCollected actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar residueCollected.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteResidueCollected = createAsyncThunk('residueCollecteds/deleteResidueCollected', async residueCollected => {
	try {
		const response = await deleteResidueCollectedApi(residueCollected);
		toast.success('ResidueCollected eliminado exitosamente.', { autoClose: 3000 });
		return { residueCollected, ...response };
	} catch (error) {
		toast.error('Error al eliminar residueCollected.', { autoClose: 3000 });
		throw new Error(error);
	}
});